import { useTranslation } from 'react-i18next';
import { DealsScreen } from '../screens/DealsScreen.js';
import { PropertiesScreen } from '../screens/properties/PropertiesScreen.js';
import { VisitsScreen } from '../screens/visits/VisitsScreen.js';
import { TwoPane } from './panes.js';

/** Properties: the list, with a property, the add flow or the edit form beside it. */
export function PropertiesPane() {
  const { t } = useTranslation();
  return (
    <TwoPane
      base="/properties"
      list={<PropertiesScreen />}
      listLabel={t('nav.properties')}
      detailLabel={t('panes.detail')}
      emptyTitle={t('panes.pickProperty')}
    />
  );
}

/** Visits: the inbox, with the open visit beside it. */
export function VisitsPane() {
  const { t } = useTranslation();
  return (
    <TwoPane
      base="/visits"
      list={<VisitsScreen />}
      listLabel={t('nav.visits')}
      detailLabel={t('panes.detail')}
      emptyTitle={t('panes.pickVisit')}
    />
  );
}

/** Deals: the list, with the open deal or its agreement beside it. */
export function DealsPane() {
  const { t } = useTranslation();
  return (
    <TwoPane
      base="/deals"
      list={<DealsScreen />}
      listLabel={t('nav.deals')}
      detailLabel={t('panes.detail')}
      emptyTitle={t('panes.pickDeal')}
    />
  );
}
